import BaseDTO from '../base/BaseDTO';
import SampleHardwareRevision from '../sample-hardware-revision/SampleHardwareRevision';

export default class SampleFirmwareRevision extends BaseDTO {

    public releaseVersion: string;
    public description: string;
    public installationStatus: string;
    public fileName: string;
    public hardwareRevisions: SampleHardwareRevision[] = [];

    constructor(data: { [key: string]: any }) {
        super(data);
        this.releaseVersion = data['releaseVersion'];
        this.description = data['description'];
        this.installationStatus = data['installationStatus'];
        this.fileName = data['fileName'];
        this.hardwareRevisions = Array.isArray(data['hardwareRevisions']) ? data['hardwareRevisions']
        .map(item => item instanceof SampleHardwareRevision ? item : new SampleHardwareRevision(item)) : [];
    }
}